import ColorSelection from './components/ColorSelection.vue'
import IconSection from './components/IconSection.vue'
import DesignSection from './components/DesignSection.vue'
import { Cropper, Preview } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import axios from 'axios'
// this is for development environment where windows.js_var is missing
import dev_js_var from './assets/js_var_dev.json';
import dev_js_data from './assets/data_dev.json';

const queryString = window.location.search;

var products, prod_keys_valid, audience_valid, products_filtered, showIconSearch, tabs_valid, designdata;
var js_var = window.js_var;
if (queryString.indexOf('dev=true') >= 0 && !js_var)  {
    js_var = dev_js_var;
    products = js_var.products;
    prod_keys_valid = undefined;
    audience_valid = new Set(["child"]);
    products_filtered = products;
    showIconSearch = js_var.showIconSearch;
    tabs_valid = [1, 2, 3, 4];
    designdata = dev_js_data;
} else {
    products = JSON.parse(js_var.products);
    prod_keys_valid = js_var.prod_keys_valid ? new Set(js_var.prod_keys_valid.split(',')) : undefined;
    audience_valid = js_var.audience_valid ? new Set(js_var.audience_valid.split(',')) : undefined;
    tabs_valid = [];
    if (prod_keys_valid) {
        products_filtered = {};
        for (var p in products) {
            if (prod_keys_valid.has(p)) {
                products_filtered[p] = products[p];
                var tabno = products[p].productTab;
                if (!tabs_valid.includes(tabno)) tabs_valid.push(tabno);
            }
        }
    }
    showIconSearch = JSON.parse(js_var.showIconSearch);
}

const dataDefault = {
    buildno: '032',
    generatedSticker: js_var.generatedSticker,
    hasMiniTextSizeError: false,
    isLoading: false,
    iconUploadConfirmed: false,
    everything: [],
    designdata: designdata,
    show_icon_upload: queryString.indexOf('upload=false') < 0,
    show_bg_upload: queryString.indexOf('upload=false') < 0,
    searchquery: "",
    searchresults: [],
    myIcons: [],
    myIconsDisplay: null,
    myBackgrounds: [],
    myBgDisplay: null,
    products: products_filtered,
    tabs_valid: tabs_valid,
    placeholderImage: js_var.placeholderImage,
    showIconSearch: showIconSearch,
    showContrast: js_var.translations.contrastRatio !== 'contrastRatio' && js_var.translations.contrastRatio !== '',
    translations: js_var.translations,
    showContrastLimit: 3.0,
    fonts: [ "Arial", "Georgia", "Times New Roman", "Trebuchet MS", "Verdana", "Chantal", "Boogaloo", "Courgette", "Leckerli One", "Patrick Hand" ],
    fontColors: [ "#000000", "#ffffff", "#00accd", "#ef3a55", "#3b8748", "#0e4e96", "#99d8dc", "#53b5d5", "#006f87", "#02405b", "#a3b53a", "#577535", "#1e4927", "#f398a4", "#ff7276", "#d7376b", "#d2232a", "#aa3a55", "#825282", "#622e59", "#ffe06a", "#fcb316", "#f15a22", "#c29981", "#c25136", "#6a4735", "#6d6e71" ],
    designEmptyImages: {},
    setEmptyImages: {},
    designShowed: false,
    backgroundLum: 1,
    forgroundLum: 0,
    contrastRatio: 10,
    uploadIcon: {
        src: null,
        type: null,
    },
    uploadBackground: {
        src: null,
        type: null,
    },
    sticker: {
        readyForCart: false,
        canvas: {},
        context: {},
        miniSticker: {
            canvas: {},
            context: {},
            dimensions: {}
        },
        selectedDesignIdx: 0,
        selectedDesign: null,
        options: {
            selectedIcon: null,
            selectedBackground: null,
            selectedBackgroundColor: null,
            selectedProduct: products.color, // color | iron
            selectedDesignName: '',
            a4name: '',
            hasRegular: true,
            hasMini: false,
            color: "#000000",
            textAlign: 0,
            fontWeight: "normal",
            fontStyle: "normal",
            fontFamily: "Arial",
            textAlignment: ["left", "center", "right"],
            largeImage: false,
            noImage: false,
            lines: {
                line1: {
                    text: null,
                    fontSize: 500,
                    errors: { regular: false, mini: false }
                },
                line2: {
                    text: null,
                    fontSize: 500,
                    errors: { regular: false, mini: false }
                },
                line3: {
                    text: null,
                    fontSize: 500,
                    errors: { regular: false, mini: false }
                }
            }

        }
    }
};


function getImageType(file, default_type) {
    const byteArray = (new Uint8Array(file)).subarray(0, 4);
    let header = '';
    for (let i = 0; i < byteArray.length; i++) {
        header += byteArray[i].toString(16);
    }
    switch (header) {
        case "89504e47":
            return "image/png";
        case "47494638":
            return "image/gif";
        case "ffd8ffe0":
        case "ffd8ffe1":
        case "ffd8ffe2":
        case "ffd8ffe3":
        case "ffd8ffe8":
            return "image/jpeg";
        default:
            return default_type;
    }
}


export default {
    name: 'App',

    components: {
        Cropper,
        Preview,
        ColorSelection,
        IconSection,
        DesignSection
    },

      mounted() {
        this.initialize();
        this.getEverything();
      },

      data () {
        return JSON.parse(JSON.stringify({ ...dataDefault })); // we don't want to reference dataDefault, to be able to reset the sticker data later
      },

      methods : {

        switchToTabFromUrl(productTabName) {
            var productFromUrlParameter = Object.values(this.products).find(product => product.name == productTabName);
            if (productFromUrlParameter) this.setProductTab(productFromUrlParameter.productTab);
        },

        loadExistingSticker() {
            Object.assign(this.$data.sticker.options, js_var.generatedSticker);

            if (this.sticker.options.selectedIcon) this.selectIcon(this.sticker.options.selectedIcon);

            if (this.sticker.options.selectedBackground) this.selectIcon(this.sticker.options.selectedBackground);

            if (this.sticker.options.selectedDesignName) {
                for (const [i, design] of this.designdata.designs.entries()) {
                    if (design.name === this.sticker.options.selectedDesignName) {
                        this.sticker.selectedDesign = design;
                        this.sticker.selectedDesignIdx = i;
                        break;
                    }
                }
            }

            this.updateTextLines();
            this.updateCanvas();
        },

        selectBackgroundColor(color) {
            this.sticker.options.selectedBackground = null;
            this.sticker.options.selectedBackgroundColor = color;
            this.backgroundLum = getColorLuminance(this.sticker.options.selectedBackgroundColor || '#ffffff');
            this.updateContrastRatio();
            this.updateCanvas();
        },

        selectIcon (icon) {

            if (icon && icon.isBackground) {
                this.sticker.options.selectedBackground = icon;
                getImageLuminance(icon.url, (lum) => {
                    this.backgroundLum = lum;
                    this.updateContrastRatio();
                });
            } else if (icon) {
                this.sticker.options.selectedIcon = icon;
            }
            else { // icon is not set
                this.sticker.options.selectedBackground = null;
                this.sticker.options.selectedIcon = null;
                this.backgroundLum = getColorLuminance(this.sticker.options.selectedBackgroundColor || '#ffffff');
                this.updateContrastRatio();
            }

            if (icon && this.sticker.options.noImage) {
                this.sticker.options.noImage = false;
            }

        },


        selectDesign(idx) {
            let design = this.designdata.designs[idx]
            if (!design)
                return;
            if (!this.designShowed) {
                this.designShowed = true;
                this.sticker.options.textAlign = 1;
            }
            this.sticker.selectedDesignIdx = idx;
            this.sticker.options.selectedDesignName = design.name;
            this.sticker.options.hasRegular = true;
            if (design.font)
                this.sticker.options.fontFamily = design.font;
            this.updateCanvas();
        },


        initialize() {
            this.sticker.canvas = document.createElement("canvas");
            this.sticker.context = this.sticker.canvas.getContext("2d");
            this.sticker.miniSticker = {};
            this.sticker.miniSticker.canvas = document.createElement("canvas");
            this.sticker.miniSticker.context = this.sticker.miniSticker.canvas.getContext("2d");
            this.sticker.miniSticker.dimensions = {
                width: 16,
                height: 6
            };
            if (localStorage.myIcons) {
                this.myIcons = JSON.parse(localStorage.myIcons);
            }
            if (localStorage.myBackgrounds) {
                this.myBackgrounds = JSON.parse(localStorage.myBackgrounds);
            }
        },

        updateOneImage(imgdef, designimg=undefined, textcolor=undefined) {
              var sticker = this.sticker;
              sticker.context.clearRect(0, 0, sticker.canvas.width, sticker.canvas.height);
              sticker.canvas.width = imgdef.dimension.width;
              sticker.canvas.height = imgdef.dimension.height;
              let marginLeft = imgdef.margin.left;
              if (designimg) {
                  // Image is predefined with background
                  sticker.context.drawImage(designimg, 0, 0);
              } else {
                  // Use selected background and icon
                  sticker.context.fillStyle = sticker.options.selectedBackgroundColor ?? "#ffffff";
                  sticker.context.fillRect(0, 0, sticker.canvas.width, sticker.canvas.height);
                  // Background image
                  let background = document.getElementById('currentBackgroundElement');
                  if (background.naturalWidth <= 1) background = null; // 1x1 placeholder is active, ignore it
                  if (background !== null) {
                      sticker.context.drawImage(background, 0, 0);
                  }
                  // Icon
                  let img = document.getElementById('currentIconElement');
                  if (img.naturalWidth <= 1) img = null; // 1x1 placeholder is active, ignore it
                  if (!sticker.options.noImage && img !== null && imgdef.imglarge) {
                      let dp = sticker.options.largeImage ? imgdef.imglarge : imgdef.imgsmall;
                      sticker.context.drawImage(img, dp.x, dp.y, dp.width, dp.height);
                      if (dp.pos !== 'bottom')
                          marginLeft = dp.x + dp.width;
                  }
              }
              if (imgdef.lines === 0)
                  return false;
              var hastextsizeerror = false;
              sticker.context.textAlign = sticker.options.textAlignment[sticker.options.textAlign];
              sticker.context.textBaseline = "middle";
              let textlines = [
                  {text: sticker.options.lines.line1.text || '', height: 0 },
                  {text: sticker.options.lines.line2.text || '', height: 0 },
                  {text: sticker.options.lines.line3.text || '', height: 0 },
              ];
              // concat line 1 and 2
              if (imgdef.cat1and2) {
                  textlines[0].text = textlines[0].text + ' ' + textlines[1].text
                  textlines[1].text = textlines[2].text;
                  textlines[2].text = '';
              }
              // Get number of lines
              let nooflines = textlines.length;
              while (nooflines > 0 && textlines[nooflines - 1].text === '') nooflines--;
              if (imgdef.lines < nooflines)
                  nooflines = imgdef.lines;
              //
              let areaheight = imgdef.dimension.height - imgdef.margin.top - imgdef.margin.bottom;
              let maxlinewidth = imgdef.dimension.width - marginLeft - imgdef.margin.right;
              let maxlineheight = nooflines > 1 ? Math.floor(areaheight / nooflines - 10) : areaheight;
              // Set x position based on alignment
              let posx = marginLeft;
              if (sticker.options.textAlign === 1)
                  posx = marginLeft + Math.floor(maxlinewidth / 2);
              else if (sticker.options.textAlign === 2)
                  posx = marginLeft + maxlinewidth;
              // Find line heights
              let totheight = 0;
              for (let i=0; i< nooflines; i++) {
                  let line = textlines[i];
                  line.height = maxlineheight;
                  while (line.height >= 30) {
                      sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight +
                          " " + line.height + "px " + this.sticker.options.fontFamily;
                      if (sticker.context.measureText(line.text).width <= maxlinewidth)
                          break;
                      line.height -= 5;
                  }
                  if (line.height < 30) {
                      sticker.options.lines['line' + (1 + i)].errors.regular = true;
                      hastextsizeerror = true;
                      line.height = 30;
                  }
                  totheight += line.height
              }
              // Write lines vertical align center
              let margintop = imgdef.margin.top + (areaheight - totheight) / 2;
              totheight = 0;
              for (let i=0; i< nooflines; i++) {
                  let line = textlines[i];
                  sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight +
                      " " + line.height + "px " + this.sticker.options.fontFamily;
                  sticker.context.fillStyle = textcolor || this.sticker.options.color;
                  sticker.context.fillText(line.text, posx, margintop + totheight + line.height / 2);
                  totheight += line.height
              }
              if (hastextsizeerror)
                  this.sticker.readyForCart = false;
              return hastextsizeerror;
        },

        extractImageFromDataUrl(dataurl) {
            var block = dataurl.split(";");
            var contentType = block[0].split(":")[1];
            var realData = block[1].split(",")[1];
            var imageBlob = this.b64toBlob(realData, contentType);
            return imageBlob;
        },

        createAllImages(a4name) {
          return new Promise(resolve => {
              var handleImages = (images) => {
                  // Add text to all images
                  let allimages = [];
                  for (let o of images) {
                      // Create image with text
                      this.updateOneImage(o.imgdef, o.img, o.textcolor)
                      let dataurl = this.sticker.canvas.toDataURL("image/png");
                      allimages.push({data: dataurl, qty: o.qty, name: o.name});
                  }
                  axios.post('https://apps.sandviks.com/tmpnametag/' + a4name, JSON.stringify(allimages),
                      {"headers": {"Content-Type": "text/plain"}})
                      .then(() => resolve(''))
                      .catch(() => resolve('error'));
              };
              // Load all images;
              var images = [];
              if (this.sticker.options.selectedProduct.productTab === 3) {
                  var imgloading = 0;
                  var design = this.designdata.designs[this.sticker.selectedDesignIdx];
                  for (let dimg of design.images) {
                      let imagename = design.name + '_' + dimg.name
                      let img = this.designEmptyImages[imagename];
                      if (img) {
                          let imgdef = design.types[dimg.type];
                          images.push({imgdef: imgdef, img: img, name: dimg.name, qty: dimg.qty, textcolor: dimg.textcolor});
                      } else {
                          img = new Image();
                          img.addEventListener('load', () => {
                              imgloading -= 1;
                              if (imgloading === 0)
                                  handleImages(images);
                          }, false);
                          imgloading += 1;
                          let imgdef = design.types[dimg.type];
                          images.push({imgdef: imgdef, img: img, name: dimg.name, qty: dimg.qty, textcolor: dimg.textcolor});
                          img.src = this.designdata.base + design.name + '/' + dimg.name + '?v=' + this.buildno;
                      }
                  }
                  if (imgloading === 0)
                      handleImages(images);
              } else {
                  var set1 = this.designdata.miscsets[0];
                  for (let imgdef of set1.images) {
                      images.push({imgdef: imgdef, img: undefined, name: imgdef.name, qty: imgdef.qty, textcolor: undefined});
                  }
                  handleImages(images);
              }
          });

        },

        updateDesignCanvas() {
            var handleImage = (img, imgitem, previewpos) => {
                let imgdef = design.types[imgitem.type];
                if (!this.updateOneImage(imgdef, img, imgitem.textcolor)) {
                //if (!this.updateOneDesignImage(img, imgitem)) {
                    let dataurl = this.sticker.canvas.toDataURL("image/png");
                    const mq = window.matchMedia('(min-width: 992px)')
                    let imgid = "design_preview_" + (mq.matches ? "d_" : "") + previewpos;
                    let previewimage = document.getElementById(imgid);
                    previewimage.src = dataurl;
                    // Use first small preview image in order line
                    if (!this.sticker.options.image && imgitem.name.startsWith('small'))
                        this.sticker.options.image = this.extractImageFromDataUrl(dataurl);
                }
            }
            this.sticker.options.lines.line3.text = '';
            this.sticker.readyForCart = true;
            var design = this.designdata.designs[this.sticker.selectedDesignIdx];
            // Use first image as regular image
            this.sticker.options.image = null;
            for (let imgitem of design.images) {
                // Only update preview images
                let previewpos = design.preview.indexOf(imgitem.name);
                if (previewpos < 0)
                    continue;
                let imagename = design.name + '_' + imgitem.name
                let img = this.designEmptyImages[imagename];
                if (img) {
                    handleImage(img, imgitem, previewpos);
                } else {
                    img = new Image();
                    img.addEventListener('load', () => {
                        // execute drawImage statements here
                        this.designEmptyImages[imagename] = img;
                        handleImage(img, imgitem, previewpos);
                    }, false);
                    img.src = this.designdata.base + design.name + '/' + imgitem.name + '?v=' + this.buildno;
                }
            }
        },

        updateMiscCanvas() {
          var handleImage = (imgdef, previewpos) => {
              if (imgdef.lines > 0 && !this.updateOneImage(imgdef)) {
                  let dataurl = this.sticker.canvas.toDataURL("image/png");
                  const mq = window.matchMedia('(min-width: 992px)')
                  let imgid = "misc_preview_" + (mq.matches ? "d_" : "") + previewpos;
                  let previewimage = document.getElementById(imgid);
                  previewimage.src = dataurl;
                  // Use first small preview image in order line
                  if (!this.sticker.options.image && imgdef.name.startsWith('small'))
                      this.sticker.options.image = this.extractImageFromDataUrl(dataurl);
              }
          }
          this.sticker.readyForCart = true;
          var set1 = this.designdata.miscsets[0];
          // Use first image as regular image
          this.sticker.options.image = null;
          for (let i=0; i<set1.images.length; i++) {
              handleImage(set1.images[i], i);
          }
        },


          updateCanvas () {
            var sticker = this.sticker;
            this.sticker.options.lines.line1.errors.regular = false;
            this.sticker.options.lines.line1.errors.mini = false;
            this.sticker.options.lines.line2.errors.regular = false;
            this.sticker.options.lines.line2.errors.mini = false;
            this.sticker.options.lines.line3.errors.regular = false;
            this.sticker.options.lines.line3.errors.mini = false;

            this.updateTextLines();

            if (this.sticker.options.selectedProduct.productTab === 3) {
                if (this.designdata)
                    this.updateDesignCanvas();
                return;
            }
            if (this.sticker.options.selectedProduct.productTab === 4) {
                this.updateMiscCanvas();
                return;
            }

            var dpi = 300;
            var scaleFactor = dpi / 72;
            var ppmm = 11.8;
            var dimensions = {
                new: {
                    width: 33,
                    height: 13
                }
            };

            var areaWidth = Math.ceil(dimensions.new.width * ppmm);
            var areaHeight = Math.ceil(dimensions.new.height * ppmm);

            if (sticker.options.selectedProduct.productTab == 1) {
                sticker.canvas.width = Math.ceil(areaWidth * scaleFactor);
                sticker.canvas.height = Math.ceil(areaHeight * scaleFactor);
            } else {
                sticker.canvas.width = 1330;
                sticker.canvas.height = 663;
            }

            if (sticker.options.selectedProduct.productTab == 1) { // fill background color for color stickers (productTab = 1)
                sticker.context.fillStyle = sticker.options.selectedBackgroundColor ?? "#ffffff";
                sticker.context.fillRect(0, 0, sticker.canvas.width, sticker.canvas.height);
            }

            var img = document.getElementById('currentIconElement');
            if (img.naturalWidth <= 1) img = null; // 1x1 placeholder is active, ignore it


            var background = document.getElementById('currentBackgroundElement');
            if (background.naturalWidth <= 1) background = null; // 1x1 placeholder is active, ignore it


            if (sticker.options.activeTextLines < 1 &&
                img === null && background === null

                ) {
                sticker.isEmpty = true;
            } else {
                sticker.isEmpty = false;
            }


            if (background !== null) {
                var backgroundWidth = background.naturalWidth;

                if (backgroundWidth === 1626) {
                    sticker.context.drawImage(background, 0, 0);
                }
                else if (backgroundWidth === 400) {
                    sticker.context.drawImage(background, 0, 0, 1626, 642);
                }
            }

            if (!sticker.options.noImage && img !== null) {
                if (sticker.options.selectedProduct.productTab == 1) {
                    // NOTE: For 1626px center image
                    if (sticker.options.activeTextLines == 0) {
                        if (sticker.options.largeImage) {
                            //sticker.context.drawImage(img, 543, 51, 540, 540);
                            sticker.context.drawImage(img, 493, 1, 640, 640);
                        } else {
                            sticker.context.drawImage(img, 588, 100, 450, 450);
                        }
                    } else {
                        // NOTE: For 1626px left image
                        if (sticker.options.largeImage) {
                            //sticker.context.drawImage(img, 30, 51, 540, 540);
                            sticker.context.drawImage(img, 1, 1, 640, 640);
                        } else {
                            sticker.context.drawImage(img, 30, 100, 450, 450);
                        }
                    }
                } else {
                    // NOTE: For 1330px center image
                    if (sticker.options.activeTextLines == 0) {
                        if (sticker.options.largeImage) {
                            sticker.context.drawImage(img, 444, 110, 460, 460);
                        } else sticker.context.drawImage(img, 444, 136, 370, 370);
                    } else {
                        // NOTE: For 1330px left image
                        if (sticker.options.largeImage) {
                            sticker.context.drawImage(img, 30, 110, 460, 460);
                        } else {
                            sticker.context.drawImage(img, 30, 136, 370, 370);
                        }
                    }
                }
            }

            sticker.context.textAlign = sticker.options.textAlignment[sticker.options.textAlign];
            sticker.context.textBaseline = "middle";

            var pxw = 500;
            var lineMarginLeft = 0;
            var lineMarginTop = 0;
            var lineWidth = 0;
            var lineMarginRight = 30;
            var textLines = [];
            var hasTextSizeError = false;
            this.hasMiniTextSizeError = false;

            if (sticker.options.activeTextLines > 0) {
                for (var index in sticker.options.lines) {
                    if (sticker.options.lines[index].text !== null) {
                        if (typeof sticker.options.lines[index].index === "undefined") {
                            sticker.options.lines[index].index = index;
                        }
                        textLines.push(sticker.options.lines[index]);
                    }
                }


                if (img == null || sticker.options.noImage == true) {
                    if (sticker.options.selectedProduct.productTab == 1) {
                        if (sticker.options.textAlign == 1) {
                            lineMarginLeft = 813;
                        } else if (sticker.options.textAlign == 2) {
                            lineMarginLeft = sticker.canvas.width - 30;
                        } else {
                            lineMarginLeft = 30;
                        }

                        lineMarginTop = sticker.canvas.height / 2;
                        lineWidth = 1550;
                    } else {
                        if (sticker.options.textAlign == 1) {
                            lineMarginLeft = 665;
                        } else if (sticker.options.textAlign == 2) {
                            lineMarginLeft = sticker.canvas.width - 30;
                        } else {
                            lineMarginLeft = 30;
                        }

                        lineMarginTop = sticker.canvas.height / 2;
                        lineWidth = 1270;
                    }

                    if (sticker.options.activeTextLines == 1) {
                        var zff = 0;
                        while (zff == 0) {
                            zff = 1;
                            sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;

                            if (sticker.context.measureText(textLines[0].text).width > lineWidth) {
                                pxw = pxw - 10;
                                zff = 0;
                            }
                        }


                        if (pxw <= 90) {
                            hasTextSizeError = true;
                            sticker.options.lines[textLines[0].index].errors.regular = true;
                        } else {
                            sticker.options.lines[textLines[0].index].fontSize = pxw;
                        }

                        if (sticker.options.selectedProduct.productTab == 1) {
                            sticker.context.fillStyle = this.sticker.options.color;
                        }

                        sticker.context.fillText(textLines[0].text, lineMarginLeft, lineMarginTop - 8 + 32, lineWidth);
                    } else if (sticker.options.activeTextLines == 2) {
                        pxw = 280;
                        zff = 0;
                        while (zff == 0) {
                            zff = 1;
                            sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;
                            if (sticker.context.measureText(textLines[0].text).width > lineWidth) {
                                pxw = pxw - 10;
                                zff = 0;
                            }
                        }


                        if (pxw <= 90) {
                            hasTextSizeError = true;
                            sticker.options.lines[textLines[0].index].errors.regular = true;
                        } else {
                            sticker.options.lines[textLines[0].index].fontSize = pxw;
                        }

                        if (sticker.options.selectedProduct.productTab == 1) sticker.context.fillStyle = this.sticker.options.color;

                        sticker.context.fillText(textLines[0].text, lineMarginLeft, lineMarginTop - (138) + 32, lineWidth);

                        pxw = 280;
                        zff = 0;
                        while (zff == 0) {
                            zff = 1;
                            sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;
                            if (sticker.context.measureText(textLines[1].text).width >= lineWidth) {
                                pxw = pxw - 10;
                                zff = 0;
                            }
                        }

                        if (pxw <= 90) {
                            sticker.options.lines[textLines[1].index].errors.regular = true;
                            hasTextSizeError = true;
                        } else {
                            sticker.options.lines[textLines[1].index].fontSize = pxw;
                        }

                        if (sticker.options.selectedProduct.productTab == 1) sticker.context.fillStyle = this.sticker.options.color;

                        sticker.context.fillText(textLines[1].text, lineMarginLeft, lineMarginTop + (132) + 32, lineWidth);
                    } else { // active text lines == 3 and no icon
                        pxw = 200;
                        zff = 0;
                        while (zff == 0) {
                            zff = 1;
                            sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;
                            if (sticker.context.measureText(textLines[0].text).width > lineWidth) {
                                pxw = pxw - 10;
                                zff = 0;
                            }
                        }


                        if (pxw <= 90) {
                            sticker.options.lines[textLines[0].index].errors.regular = true;
                            hasTextSizeError = true;
                        } else {
                            sticker.options.lines[textLines[0].index].fontSize = pxw;
                        }

                        if (sticker.options.selectedProduct.productTab == 1) sticker.context.fillStyle = this.sticker.options.color;


                        sticker.context.fillText(textLines[0].text, lineMarginLeft, lineMarginTop - (192) + 32, lineWidth);

                        pxw = 200;
                        zff = 0;
                        while (zff == 0) {
                            zff = 1;
                            sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;
                            if (sticker.context.measureText(textLines[1].text).width > lineWidth) {
                                pxw = pxw - 10;
                                zff = 0;
                            }
                        }


                        if (pxw <= 90) {
                            sticker.options.lines[textLines[1].index].errors.regular = true;
                            hasTextSizeError = true;
                        } else {
                            sticker.options.lines[textLines[1].index].fontSize = pxw;
                        }

                        if (sticker.options.selectedProduct.productTab == 1) sticker.context.fillStyle = this.sticker.options.color;

                        sticker.context.fillText(textLines[1].text, lineMarginLeft, lineMarginTop - 3 + 32, lineWidth);

                        pxw = 200;
                        zff = 0;
                        while (zff == 0) {
                            zff = 1;
                            sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;

                            if (sticker.context.measureText(textLines[2].text).width > lineWidth) {
                                pxw = pxw - 10;
                                zff = 0;
                            }
                        }



                        if (pxw <= 90) {
                            sticker.options.lines[textLines[2].index].errors.regular = true;
                            hasTextSizeError = true;
                        } else {
                            sticker.options.lines[textLines[2].index].fontSize = pxw;
                        }

                        if (sticker.options.selectedProduct.productTab == 1) sticker.context.fillStyle = this.sticker.options.color;

                        sticker.context.fillText(textLines[2].text, lineMarginLeft, lineMarginTop + (186) + 32, lineWidth);
                    }
                } else {
                    if (sticker.options.selectedProduct.productTab == 1) {
                        pxw = 240;
                        if (sticker.options.textAlign == 1) {
                            if (sticker.options.largeImage) {
                                lineMarginLeft = 1113;
                            } else {
                                lineMarginLeft = 1068;
                            }
                        } else if (sticker.options.textAlign == 2) {
                            if (sticker.options.largeImage) {
                                lineMarginLeft = sticker.canvas.width - 30;
                            } else {
                                lineMarginLeft = sticker.canvas.width - 30;
                            }
                        } else {
                            if (sticker.options.largeImage) {
                                lineMarginLeft = 670;
                            } else {
                                lineMarginLeft = 580;
                            }
                        }

                        lineMarginTop = sticker.canvas.height / 2;

                        if (sticker.options.largeImage) {
                            lineWidth = 850;
                        } else {
                            lineWidth = 1046;
                        }
                    } else {
                        pxw = 240;
                        if (sticker.options.textAlign == 1) {
                            if (sticker.options.largeImage) {
                                lineMarginLeft = 900;
                            } else {
                                lineMarginLeft = 900;
                            }
                        } else if (sticker.options.textAlign == 2) {
                            if (sticker.options.largeImage) {
                                lineMarginLeft = sticker.canvas.width - 30;
                            } else {
                                lineMarginLeft = sticker.canvas.width - 30;
                            }
                        } else {
                            if (sticker.options.largeImage) {
                                lineMarginLeft = 550;
                            } else {
                                lineMarginLeft = 460;
                            }
                        }

                        lineMarginTop = sticker.canvas.height / 2;

                        if (sticker.options.largeImage) {
                            lineWidth = 700;
                        } else {
                            lineWidth = 800;
                        }
                    }

                    if (sticker.options.textAlign < 2) {
                        lineWidth -= 30;
                    }

                    if (sticker.options.activeTextLines == 1) {
                        pxw = 500;
                        zff = 0;
                        while (zff == 0) {
                            zff = 1;
                            sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;
                            if (sticker.context.measureText(textLines[0].text).width > lineWidth) {
                                pxw = pxw - 10;
                                zff = 0;
                            }
                        }

                        if (pxw <= 90) {
                            sticker.options.lines[textLines[0].index].errors.regular = true;
                            hasTextSizeError = true;
                        } else {
                            sticker.options.lines[textLines[0].index].fontSize = pxw;
                        }

                        if (sticker.options.selectedProduct.productTab == 1) sticker.context.fillStyle = this.sticker.options.color;

                        sticker.context.fillText(textLines[0].text, lineMarginLeft, lineMarginTop - 8 + 32, lineWidth);
                    } else if (sticker.options.activeTextLines == 2) {
                        pxw = 280;
                        zff = 0;
                        while (zff == 0) {
                            zff = 1;
                            sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;
                            if (sticker.context.measureText(textLines[0].text).width > lineWidth) {
                                pxw = pxw - 5;
                                zff = 0;
                            }
                        }


                        if (pxw <= 90) {
                            sticker.options.lines[textLines[0].index].errors.regular = true;
                            hasTextSizeError = true;
                        } else {
                            sticker.options.lines[textLines[0].index].fontSize = pxw;
                        }

                        if (sticker.options.selectedProduct.productTab == 1) sticker.context.fillStyle = this.sticker.options.color;

                        sticker.context.fillText(textLines[0].text, lineMarginLeft, lineMarginTop - (138) + 32, lineWidth);

                        pxw = 280;
                        zff = 0;
                        while (zff == 0) {
                            zff = 1;
                            sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;
                            if (sticker.context.measureText(textLines[1].text).width > lineWidth) {
                                pxw = pxw - 5;
                                zff = 0;
                            }
                        }



                        if (pxw <= 90) {
                            sticker.options.lines[textLines[1].index].errors.regular = true;
                            hasTextSizeError = true;
                        } else {
                            sticker.options.lines[textLines[1].index].fontSize = pxw;
                        }

                        if (sticker.options.selectedProduct.productTab == 1) sticker.context.fillStyle = this.sticker.options.color;

                        sticker.context.fillText(textLines[1].text, lineMarginLeft, lineMarginTop + (132) + 32, lineWidth);
                    } else { // active text lines == 3 and has icon
                        pxw = 190;

                        zff = 0;
                        while (zff == 0) {
                            zff = 1;
                            sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;
                            if (sticker.context.measureText(textLines[0].text).width > lineWidth) {
                                pxw = pxw - 10;
                                zff = 0;
                            }
                        }



                        if (pxw <= 90) {
                            sticker.options.lines[textLines[0].index].errors.regular = true;
                            hasTextSizeError = true;
                        } else {
                            sticker.options.lines[textLines[0].index].fontSize = pxw;
                        }

                        if (sticker.options.selectedProduct.productTab == 1) sticker.context.fillStyle = this.sticker.options.color;

                        sticker.context.fillText(textLines[0].text, lineMarginLeft, lineMarginTop - (192) + 32, lineWidth);
                        sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;
                        pxw = 190;
                        zff = 0;
                        while (zff == 0) {
                            zff = 1;
                            sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;
                            if (sticker.context.measureText(textLines[1].text).width > lineWidth) {
                                pxw = pxw - 10;
                                zff = 0;
                            }
                        }


                        if (pxw <= 90) {
                            sticker.options.lines[textLines[1].index].errors.regular = true;
                            hasTextSizeError = true;
                        } else {
                            sticker.options.lines[textLines[1].index].fontSize = pxw;
                        }

                        if (sticker.options.selectedProduct.productTab == 1) sticker.context.fillStyle = this.sticker.options.color;

                        sticker.context.fillText(textLines[1].text, lineMarginLeft, lineMarginTop - 3 + 32, lineWidth);
                        sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;
                        pxw = 190;
                        zff = 0;

                        while (zff == 0) {
                            zff = 1;
                            sticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;
                            if (sticker.context.measureText(textLines[2].text).width > lineWidth) {
                                pxw = pxw - 10;
                                zff = 0;
                            }
                        }


                        if (pxw <= 90) {
                            sticker.options.lines[textLines[2].index].errors.regular = true;
                            hasTextSizeError = true;
                        } else {
                            sticker.options.lines[textLines[2].index].fontSize = pxw;
                        }

                        if (sticker.options.selectedProduct.productTab == 1) sticker.context.fillStyle = this.sticker.options.color;

                        sticker.context.fillText(textLines[2].text, lineMarginLeft, lineMarginTop + (186) + 32, lineWidth);
                    }
                }

            }

            if (sticker.options.hasMini) {
                sticker.miniSticker.area = {
                    width: Math.ceil(sticker.miniSticker.dimensions.width * ppmm),
                    height: Math.ceil(sticker.miniSticker.dimensions.height * ppmm)
                };

                sticker.miniSticker.canvas.width = Math.ceil(sticker.miniSticker.area.width * scaleFactor);
                sticker.miniSticker.canvas.height = Math.ceil(sticker.miniSticker.area.height * scaleFactor);

                sticker.miniSticker.context.fillStyle = sticker.options.selectedBackgroundColor ?? "#ffffff";
                sticker.miniSticker.context.fillRect(0, 0, sticker.miniSticker.canvas.width, sticker.miniSticker.canvas.height);

                if (background !== null) {
                    if (backgroundWidth === 1626 || backgroundWidth === 400) {
                        var calculatedHeight = Math.ceil((background.naturalHeight * sticker.miniSticker.canvas.width) / background.naturalWidth);

                        sticker.miniSticker.context.drawImage(background, 0, 0, sticker.miniSticker.canvas.width, calculatedHeight);
                    }
                }

                var miniMargin = 0.2; // 2mm
                var miniYPos = Math.ceil(miniMargin * ppmm * scaleFactor);
                var miniHeight = Math.ceil(sticker.miniSticker.canvas.height - miniYPos * 2);
                var miniWidth = miniHeight;
                var miniXPos = Math.ceil((sticker.miniSticker.canvas.width - miniWidth) / 2);

                if (sticker.options.activeTextLines > 0) {
                    miniXPos = miniYPos;
                }

                if (!sticker.options.noImage && img !== null) {
                    sticker.miniSticker.context.drawImage(img, miniXPos, miniYPos, miniWidth, miniHeight);
                }

                sticker.miniSticker.context.textAlign = sticker.options.textAlignment[sticker.options.textAlign];
                sticker.miniSticker.context.textBaseline = "middle";

                pxw = 200;
                lineMarginLeft = Math.ceil(miniMargin * ppmm * scaleFactor);
                lineMarginRight = lineMarginLeft;

                lineMarginTop = sticker.miniSticker.canvas.height / 2 - lineMarginLeft;
                if (sticker.options.activeTextLines > 0) {
                    if (img == null || sticker.options.noImage == true) {
                        if (sticker.options.textAlign == 1) {
                            lineMarginLeft = sticker.miniSticker.canvas.width / 2;
                        } else if (sticker.options.textAlign == 2) {
                            lineMarginLeft = sticker.miniSticker.canvas.width - lineMarginLeft;
                        }

                        lineWidth = sticker.miniSticker.canvas.width;
                    } else {
                        if (sticker.options.textAlign == 1) {
                            lineMarginLeft = sticker.miniSticker.canvas.width / 2 + lineMarginLeft + miniWidth / 2;
                        } else if (sticker.options.textAlign == 2) {
                            lineMarginLeft = sticker.miniSticker.canvas.width - lineMarginLeft;
                        } else {
                            lineMarginLeft = miniWidth + miniXPos + lineMarginLeft;
                        }

                        lineWidth = sticker.miniSticker.canvas.width - miniWidth;
                    }

                    lineWidth -= lineMarginRight * 4;

                    zff = 0;
                    while (zff == 0) {
                        zff = 1;
                        sticker.miniSticker.context.font = this.sticker.options.fontStyle + " " + this.sticker.options.fontWeight + " " + pxw + "px " + this.sticker.options.fontFamily;

                        if (sticker.miniSticker.context.measureText(textLines[0].text).width > lineWidth) {
                            pxw = pxw - 10;
                            zff = 0;
                        }
                    }

                    this.hasMiniTextSizeError = false;

                    if (pxw <= 90) {
                        this.hasMiniTextSizeError = true;
                        sticker.options.lines[textLines[0].index].errors.mini = true;
                    } else {
                        sticker.options.lines[textLines[0].index].fontSizeMini = pxw;
                    }

                    if (sticker.options.selectedProduct.productTab == 1) sticker.miniSticker.context.fillStyle = this.sticker.options.color;

                    sticker.miniSticker.context.fillText(textLines[0].text, lineMarginLeft, lineMarginTop + 7, lineWidth);
                }
            }

            var disableSubmitButton = false;

            if (sticker.options.hasMini && this.hasMiniTextSizeError) {
                disableSubmitButton = true;
            }

            if (sticker.options.hasRegular && hasTextSizeError) {
                disableSubmitButton = true;
            }


            if ((!sticker.options.lines.line1.text && !sticker.options.lines.line2.text && !sticker.options.lines.line3.text) // no text
                && (sticker.options.noImage === true || sticker.options.selectedIcon === null) // no icon
                && sticker.options.selectedBackground === null // no bg image
                && sticker.options.selectedBackgroundColor === null) // no bg color
            {
                disableSubmitButton = true;
            }

            this.sticker.readyForCart = !disableSubmitButton;

            this.export(sticker);

            this.updatePreview();
        },


        updatePreview () { // NOTE: binding the <img> src-attribute directly to URL.createObjectURL(this.sticker.options.image) performs more sluggish than the code below

            var previewimage = document.getElementById("previewimage");
            var previewimage2 = document.getElementById("previewimage2");

            if(this.sticker.options.image){
                previewimage.src = URL.createObjectURL(this.sticker.options.image);
                previewimage2.src = previewimage.src;
            }
            if (this.sticker.options.hasMini) {

                var previewMiniImage = document.getElementById("previewMiniImage");
                var previewMiniImage2 = document.getElementById("previewMiniImage2");

                if (this.sticker.options.miniImage){
                    previewMiniImage.src = URL.createObjectURL(this.sticker.options.miniImage);
                    previewMiniImage2.src = previewMiniImage.src;
                }
            }
        },


        updateTextLines() {
            var sticker = this.sticker;
            var activeTextLines = 0;
            for (var index in sticker.options.lines) {
                if (sticker.options.lines[index].text !== null) {
                    activeTextLines += 1;
                }
            }
            if (activeTextLines != sticker.options.activeTextLines) {
                sticker.options.activeTextLines = activeTextLines;
            }
        },



        export (sticker) {
            var dataUrl = sticker.canvas.toDataURL("image/png");
            // Split the base64 string in data and contentType
            var block = dataUrl.split(";");
            // Get the content type of the image
            var contentType = block[0].split(":")[1];
            // get the real base64 content of the file
            var realData = block[1].split(",")[1];
            // Convert it to a blob to upload
            var imageBlob = this.b64toBlob(realData, contentType);

            sticker.options.image = imageBlob;

            if (sticker.options.hasMini) {
                dataUrl = sticker.miniSticker.canvas.toDataURL("image/png");
                // Split the base64 string in data and contentType
                block = dataUrl.split(";");
                // Get the content type of the image
                contentType = block[0].split(":")[1];
                // get the real base64 content of the file
                realData = block[1].split(",")[1];

                // Convert it to a blob to upload
                imageBlob = this.b64toBlob(realData, contentType);

                sticker.options.miniImage = imageBlob;
            }
        },



         b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || "";
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        },




        updateText(event) {
            var element = event.target;
            var lineIndex = element.id,
                lineProperty = "text",
                value = element.value;
            var sticker = this.sticker;

            if (typeof value === "undefined" || value.replace(/\s/g, "") == "") {
                value = null;
            }

            if (event.keyCode != 46 && event.keyCode != 8) {
                if (sticker.options.hasRegular && sticker.options.lines[lineIndex].fontSize <= 90) {
                    sticker.options.hasLineErrors = true;
                } else {
                    sticker.options.hasLineErrors = false;
                }

                if (sticker.options.hasMini && sticker.options.lines[lineIndex].fontSizeMini <= 90) {
                    sticker.options.hasLineErrors = true;
                } else {
                    sticker.options.hasLineErrors = false;
                }
            }

            if (sticker.options.hasLineErrors) {
                return false;
            }

            sticker.options.lines[lineIndex][lineProperty] = value;

            this.updateCanvas();
        },

        updateFontColor (color) {
            this.sticker.options.color = color;
            this.updateContrastRatio();
            if (this.sticker.options.lines.line1.text !== null || this.sticker.options.lines.line2.text !== null || this.sticker.options.lines.line3.text !== null) {
                this.updateCanvas();
            }
        },

        updateContrastRatio () {
            let forgroundLum = getColorLuminance(this.sticker.options.color || '#000000');
            this.contrastRatio = getLuminanceRatio(forgroundLum, this.backgroundLum);
        },

        updateTextAlign(align) {
            this.sticker.options.textAlign = align;
            this.updateCanvas();
        },

        updateFontStyle(fontStyle) {
            this.sticker.options.fontStyle = this.sticker.options.fontStyle === fontStyle ? 'normal' : fontStyle;
            this.updateCanvas();
        },

        updateFontWeight(fontWeight) {
            this.sticker.options.fontWeight = this.sticker.options.fontWeight === fontWeight ? 'normal' : fontWeight;
            this.updateCanvas();
        },

        updateFontFamily(font) {
            this.sticker.options.fontFamily = font;
            if (this.sticker.options.selectedProduct.productTab === 3)
                this.designdata.designs[this.sticker.selectedDesignIdx].font = font;
            this.updateCanvas();
        },

        updateLargeImage () {
            this.sticker.options.largeImage = !this.sticker.options.largeImage;
            this.updateCanvas();
        },

        updateNoImage() {
            this.sticker.options.noImage = !this.sticker.options.noImage;
            this.updateCanvas();
        },

        setProductTab(productTab) {
            if (this.sticker.options.selectedProduct.productTab !== productTab) {
                this.selectIcon(null);
                if (productTab === 3) {
                    this.sticker.options.selectedProduct = this.products.design;
                    this.selectDesign(this.sticker.selectedDesignIdx);
                } else {
                    if (productTab === 2)
                        this.sticker.options.selectedProduct = this.products.iron;
                    else if (productTab === 4)
                        this.sticker.options.selectedProduct = this.products.misc;
                    else
                        this.sticker.options.selectedProduct = this.products.color;
                    this.updateStickerVariant(this.sticker.options.selectedProduct);
                }
                this.clear(false);
            }

        },

        updateStickerVariant (product) {
            this.sticker.options.selectedProduct = product;
            if (product.variant == "normal" || product.variant == "reflective") {
                this.sticker.options.hasMini = false;
            }
            if (product.variant == "mini") {
                this.sticker.options.hasRegular = false;
            }
            if (product.variant == "mini" || product.variant == "pack") {
                this.sticker.options.hasMini = true;
            }
            if (product.variant == "normal" || product.variant == "pack" || product.variant == "reflective") {
                this.sticker.options.hasRegular = true;
            }
            this.updateCanvas();
        },

        resetSticker() {
            var defaultData = JSON.parse(JSON.stringify({ ...dataDefault })); // skipping object references
            Object.assign(this.sticker.options, defaultData.sticker.options);

            this.initialize();
            this.updateCanvas();
        },

        uuidv4() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
        },

        async addToCart () {

            if (this.sticker.options.noImage) {
                this.sticker.options.selectedIcon = null; // we don't need to pass icon when noImage is true.
            }

            this.isLoading = true;
            if ([3, 4].indexOf(this.sticker.options.selectedProduct.productTab) >= 0) {
                let a4name = '';
                let hostname = window.location.hostname.split('.').slice(-2)[0];
                if (this.sticker.options.selectedProduct.productTab === 3) {
                    a4name = `${hostname}_${this.sticker.options.selectedDesignName}_${this.uuidv4()}.json`;
                } else {
                    a4name = `${hostname}_misc_${this.uuidv4()}.json`;
                }
                this.sticker.options.a4name = a4name;
                var result = '';
                try {
                    result = await this.createAllImages(a4name);
                } catch (error) {
                    console.log(error);
                    result = 'error';
                }
                if (result === 'error') {
                    alert("Sorry, we had an error! Please reload the page and try again");
                    this.isLoading = false;
                    return;
                }
            } else {
                this.sticker.options.a4name = '';
            }

            var requestData = {
                action: "sticker_add_to_cart",
                emoji: this.sticker.options.selectedIcon !== null ? this.sticker.options.selectedIcon.url : "",
                line1: this.sticker.options.lines.line1.text,
                line2: this.sticker.options.lines.line2.text,
                line3: this.sticker.options.lines.line3.text,
                textAlign: this.sticker.options.textAlign,
                cartItemEdit: new URL(window.location.href).searchParams.get("cart_item_edit"),
                backgroundImage: this.sticker.options.selectedBackground !== null ? this.sticker.options.selectedBackground.url : "",
                productName: this.sticker.options.selectedProduct.productTab,
                product: this.sticker.options.selectedProduct.id,
                stickName: this.sticker.options.selectedProduct.name,
                stickerObject: JSON.stringify(this.sticker.options),
                a4name: this.sticker.options.a4name
            };

            var formData = new FormData();

            for (var key in requestData) {
                formData.append(key, requestData[key]);
            }

            if (this.sticker.options.hasRegular) {
                formData.append("image_url", this.sticker.options.image, "generatedImage.png");
            }

            if (this.sticker.options.hasMini) {
                formData.append("image_mini_url", this.sticker.options.miniImage, "generatedMiniImage.png");
            }

            if (!this.sticker.options.noImage && this.sticker.options.selectedIcon?.name) {
                LogToGa(this.sticker.options.selectedIcon.name, 'Icons', 'add icon to cart');
            }

            if (this.sticker.options.selectedBackground?.name) {
                LogToGa(this.sticker.options.selectedBackground.name);
            }
            else if (this.sticker.options.selectedBackgroundColor) {
                LogToGa(this.sticker.options.selectedBackgroundColor);
            }

            axios({ method: 'POST', url: js_var.ajax_url, data: formData })
            .then((response) => {
                if (response.data && response.data.cartkey) { // save the current sticker state in case users clicks "back" in browser
                    var url = UpdateQueryString("cart_item_edit", response.data.cartkey, window.location.href);
                    history.pushState({ url: url }, null, url);
                }
                window.location.href = js_var.cart_url;
            }).catch((error) => {
                alert("Sorry, we have an error!");
                console.log(error);
            }).finally(() => this.isLoading = false);

        },


        clear(focus) {
            this.searchquery = '';
            this.searchresults = [];
            if (focus) this.focusInput('searchqueryinput');
        },

        search() {

            this.searchresults = [];

            if (this.searchquery == "") {
                return;
            }

            this.filteredTabs.forEach(tab => {
                tab.icons
                    .filter(i => i.isBackground === false)
                    .forEach(icon => {
                    if (icon.name != null && icon.name.toLowerCase().startsWith(this.searchquery.toLowerCase())) {
                        this.searchresults.push(icon);
                    }
                });
            });

        },

        getEverything() {
            let _this = this;
            let r1 = axios.get('/wp-content/plugins/stickers/design/data.json?v=' + _this.buildno);
            let r2 = axios.get('/wp-json/stickersadmin/icon?v=' + _this.buildno);
            axios.all([r1, r2]).then(axios.spread(function(...response) {
                if (queryString.indexOf('dev=true') < 0) {
                    _this.designdata = response[0].data;
                }
                _this.everything = JSON.parse(response[1].data);
                if (typeof js_var.generatedSticker === "object") {
                    _this.loadExistingSticker();
                } else { // ok to check for product type in url query
                    var productTabName = new URL(window.location.href).searchParams.get("merker");
                    if (productTabName) _this.switchToTabFromUrl(productTabName);
                }
                // filter all icon tabs (everything) by audience
                if (audience_valid) {
                    _this.everything = _this.everything.filter(tab =>
                        tab.isChild && audience_valid.has('child') || tab.isAdult && audience_valid.has('adult')
                        || tab.isBusiness && audience_valid.has('business'));
                }
                // uploaded icons
                let myicontag = _this.everything.find((e) => !e.isBackground);
                if (myicontag === undefined || myicontag.icons.length > 0) {
                    _this.show_icon_upload = false;
                } else {
                    _this.myIconsDisplay = myicontag.icons;
                    if (_this.myIcons.length > 0) {
                        for (let i=0; i<_this.myIcons.length; i++) {
                            let img = _this.myIcons[i];
                            let imgname = 'myIcons' + (i + 1);
                            _this.myIconsDisplay.push({url: img, id: imgname, name: imgname,
                                isBackground: false, isUploaded: true, compatibleProducts: '440'});
                        }
                    }
                }
                let mybgtag = _this.everything.find((e) => e.isBackground && !e.colors);
                if (mybgtag === undefined || mybgtag.icons.length > 0) {
                    _this.show_bg_upload = false;
                } else {
                    _this.myBgDisplay = mybgtag.icons;
                    if (_this.myBackgrounds.length > 0) {
                        for (let i=0; i<_this.myBackgrounds.length; i++) {
                            let img = _this.myBackgrounds[i];
                            let imgname = 'myBackgrounds' + (i + 1);
                            _this.myBgDisplay.push({url: img, id: imgname, name: imgname, isBackground: true,
                                isUploaded: true, compatibleProducts: '440'});
                        }
                    }
                }
            }));
        },

        focusInput: function (inputRef) {
            this.$refs[inputRef].focus();
        },

        getPreviewUrl: function(image) {
            return image ? URL.createObjectURL(image) : "//:0";
        },

        loadIconBtnClick() {
            let modal = document.getElementById("loadIconWarning");
            modal.returnValue = ''
            modal.showModal();
            modal.addEventListener('close', () => {
                if (modal.returnValue === 'ok') {
                    modal.returnValue = ''
                    this.iconUploadConfirmed = true;
                    setTimeout(() => document.getElementById('loadIconInput').click(), 100)
                }
            })
        },

        loadIcon(event) {
          // Load image
          this.iconUploadConfirmed = false;
          console.log('file selected ' + event.target)
          const { files } = event.target
          if (files && files[0]) {
              if (this.uploadIcon.src) {
                  URL.revokeObjectURL(this.uploadIcon.src)
              }
              const blob = URL.createObjectURL(files[0]);
              const reader = new FileReader();
              reader.onload = (e) => {
                  this.uploadIcon = {
                      src: blob,
                      type: getImageType(e.target.result, files[0].type),
                  };
              };
              reader.readAsArrayBuffer(files[0]);
          }
        },

        cropIcon(event, round=false) {
          const { canvas } = this.$refs.cropper.getResult();
          // Resize to 200 x 200;
          var canvas2 = document.createElement("canvas");
          canvas2.height = canvas2.width = 200;
          var ctx = canvas2.getContext("2d");
          if (round) {
              ctx.arc(100,100, 100, 0, Math.PI*2,true);
              ctx.clip();
          }
          ctx.drawImage(canvas, 0, 0, 200, 200);
          var imgurl = canvas2.toDataURL('image/png');
          this.myIcons.unshift(imgurl);
          var imgname = 'myIcons' + this.myIcons.length;
          localStorage.myIcons = JSON.stringify(this.myIcons);
          this.myIconsDisplay.unshift({url: imgurl, id: imgname, name: imgname, isBackground: false,
                  isUploaded: true, compatibleProducts: '440'});
          this.resetIcon();
          // set tab and select icon
          this.$refs.icon_view.setActiveTab(0);
          this.selectIcon(this.myIconsDisplay[0]);
        },

        cropIconRound(event) {
            this.cropIcon(event,true);
        },

        deleteIcon(name) {
            for (let i=0; i<this.myIconsDisplay.length; i++) {
                if (this.myIconsDisplay[i].name === name) {
                    this.myIconsDisplay.splice(i, 1);
                    this.myIcons.splice(i, 1);
                    localStorage.myIcons = JSON.stringify(this.myIcons);
                    break;
                }
            }
        },

        resetIcon() {
            this.uploadIcon = {
              src: null,
              type: null
          }
        },

        loadBackground(event) {
          // Load image
          const { files } = event.target;
          if (files && files[0]) {
              if (this.uploadBackground.src) {
                  URL.revokeObjectURL(this.uploadBackground.src)
              }
              const blob = URL.createObjectURL(files[0]);
              const reader = new FileReader();
              reader.onload = (e) => {
                  this.uploadBackground = {
                      src: blob,
                      type: getImageType(e.target.result, files[0].type),
                  };
              };
              reader.readAsArrayBuffer(files[0]);
          }
        },

        cropBackground() {
          const { canvas } = this.$refs.cropperbg.getResult();
          // Resize to 400 x 158;
          var canvas2 = document.createElement("canvas");
          canvas2.width = 400;
          canvas2.height = 158;
          var ctx = canvas2.getContext("2d");
          ctx.drawImage(canvas, 0, 0, 400, 158);
          var imgurl = canvas2.toDataURL('image/jpeg');
          this.myBackgrounds.unshift(imgurl);
          var imgname = 'myBackgrounds' + this.myBackgrounds.length;
          localStorage.myBackgrounds = JSON.stringify(this.myBackgrounds);
          this.myBgDisplay.unshift({url: imgurl, id: imgname, name: imgname, isBackground: true,
                  isUploaded: true, compatibleProducts: '440'});
          this.resetBackground();
          // set tab and select background
          this.$refs.bg_view.setActiveTab(0);
          this.selectIcon(this.myBgDisplay[0]);
        },

        deleteBackground(name) {
            for (let i=0; i<this.myBgDisplay.length; i++) {
                if (this.myBgDisplay[i].name === name) {
                    this.myBgDisplay.splice(i, 1);
                    this.myBackgrounds.splice(i, 1);
                    localStorage.myBackgrounds = JSON.stringify(this.myBackgrounds);
                    break;
                }
            }
        },

        resetBackground() {
          this.uploadBackground = {
              src: null,
              type: null
          }
        },

      },

      computed: {

        filteredTabs() {
            return this.everything.filter(tab => tab.compatibleProductIds && tab.compatibleProductIds.includes(this.sticker.options.selectedProduct.id)
                && (tab.icons.length > 0 || (tab.colors && tab.colors.length > 0)));
        },

      }
}

function LogToGa(valueTotrack, category = 'Backgrounds', action = 'add background to cart') {
    if (valueTotrack && typeof(window.ga) === 'function') {
        window.ga('send', {
            hitType: 'event',
            eventCategory: category,
            eventAction: action,
            eventLabel: valueTotrack,
            transport: 'beacon',
            nonInteraction: true
        });
    }
}

function UpdateQueryString(key, value, url) {
    if (!url) url = window.location.href;
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
        hash;

    if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null) {
            return url.replace(re, '$1' + key + "=" + value + '$2$3');
        }
        else {
            hash = url.split('#');
            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        }
    }
    else {
        if (typeof value !== 'undefined' && value !== null) {
            var separator = url.indexOf('?') !== -1 ? '&' : '?';
            hash = url.split('#');
            url = hash[0] + separator + key + '=' + value;
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        }
        else {
            return url;
        }
    }
}

function hexToRgb(hex) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.trim().replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

function luminance(r, g, b) {
    var a = [r, g, b].map(function (v) {
        v /= 255;
        return v <= 0.03928
            ? v / 12.92
            : Math.pow( (v + 0.055) / 1.055, 2.4 );
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

function getLuminanceRatio(lum1, lum2) {
    var lum = lum1 > lum2 ? ((lum2 + 0.05) / (lum1 + 0.05)) : ((lum1 + 0.05) / (lum2 + 0.05));
    return 1 / lum;
}

function getColorLuminance(color) {
    const colorrgb = hexToRgb(color);
    return luminance(colorrgb.r, colorrgb.g, colorrgb.b);
}

function getImageLuminance(imgsrc, callback) {
    // Load image
    var img = document.createElement("img");
    img.src = imgsrc;
    img.style.display = "none";
    document.body.appendChild(img);

    img.onload = function() {
        // create canvas
        var canvas = document.createElement("canvas");
        canvas.width = this.width;
        canvas.height = this.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(this,0,0);
        var w = Math.floor(canvas.width / 4);
        var h = Math.floor(canvas.height / 4);
        var imageData = ctx.getImageData(w, h, canvas.width - (w * 2), canvas.height - (h * 2));
        var data = imageData.data;
        var c = 0, r = 0, g = 0, b = 0;
        for(var x = 0, len = data.length; x < len; x+=4) {
            c += 1;
            r += data[x];
            g += data[x+1];
            b += data[x+2];
        }
        r = Math.floor(r / c);
        g = Math.floor(g / c);
        b = Math.floor(b / c);
        var lum = luminance(r, g, b);
        callback(lum);
    }
}


// If user clicks 'back' button i browser, use the url previously saved with history.pushState()
window.onpopstate = function(e) {
    var state = e.originalEvent.state;
    if (state !== null) {
        document.title = state.title;
        document.location = state.url;
    }
};